import { FC, useMemo } from 'react'
import { FloatingPane, SubscriptionFloatingPane as SubscriptionFloatingPaneType } from 'interfaces/floatingPanes'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { SubscriptionDonePane } from 'components/features/pfm/SubscriptionPane/SubscriptionDonePane'
import { SubscriptionWelcomePane } from 'components/features/pfm/SubscriptionPane/SubscriptionWelcomePane'
import { useSimpleGuard, isFetchableLoading } from 'helpers/loadableHelpers'
import { subscriptionGuard } from 'guards/subscriptionGuards'
import { subscriptionInfoSelector } from 'selectors/subscriptionSelectors'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import { SubscriptionPaymentPane } from 'components/features/pfm/SubscriptionPane/SubscriptionPaymentPane'

export const TYPED_SUBSCRIPTION_PANE: Pick<FloatingPane, 'type'> = {
  type: 'subscription',
}

type SubscriptionFloatingPaneProps = {
}

export const SubscriptionFloatingPane: FC<SubscriptionFloatingPaneProps> = (props) => {
  const {} = props

  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, TYPED_SUBSCRIPTION_PANE)) as SubscriptionFloatingPaneType | null

  useSimpleGuard(subscriptionGuard, {}, 'SubscriptionFloatingPane')

  const fetcheble = useStoreSelector(subscriptionInfoSelector)
  const isLoading = isFetchableLoading(fetcheble)

  if (isLoading) {
    return (
      <LoadingOverlay />
    )
  }

  if (!fetcheble.data || !pane) {
    return null
  }


  switch (pane.mode) {
    case 'welcome':

      return (
        <SubscriptionWelcomePane />
      )

    case 'new-payment':
    case 'edit-payment':
      return (
        <SubscriptionPaymentPane
          isEdit={ pane.mode === 'edit-payment' }
        />
      )

    case 'done':
      return (
        <SubscriptionDonePane />
      )
  }

}
